import { View } from 'foundations-components/components/View';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { AC_PAGE_MAX_INLINE_SIZE } from 'academy-navigation-lib/components/ACPage/ACPage';
import { jsx as _jsx } from "react/jsx-runtime";
const OnboardingSectionLayout = ({
  backgroundColor,
  children
}) => {
  const {
    isMobile,
    isTablet
  } = useMediaQuery();
  return /*#__PURE__*/_jsx(View, {
    backgroundColor: backgroundColor,
    paddingBlockEnd: isTablet ? '600' : '1100',
    paddingBlockStart: isMobile ? '400' : isTablet ? '600' : '1100',
    paddingInline: isMobile ? '400' : '1100',
    children: /*#__PURE__*/_jsx(View, {
      marginInline: "auto",
      maxInlineSize: `${AC_PAGE_MAX_INLINE_SIZE}px`,
      children: children
    })
  });
};
export default OnboardingSectionLayout;